const inkeep_ai_bot = {
    intro_message: 'مرحبًا، أنا Logto AI!\n\nأنا مساعد AI مدرب على التوثيقات، المقالات التعليمية، ومحتويات أخرى.\n\nاسألني أي شيء عن `Logto`.',
    chat_placeholder: 'اسأل Logto AI سؤالك للحصول على دليل خطوة بخطوة',
    disclaimer_label: 'إخلاء المسؤولية من Logto AI',
    disclaimer_tooltip: 'الإجابات مولدة بواسطة AI وقد تحتاج إلى التحقق.',
    example_questions_label: 'أسئلة نموذجية',
    example_questions: [
        'دليل البدء السريع لإعداد Logto',
        'تهيئة هندسة تعدد النطاقات',
        'كيفية دمج الملف الشخصي للمستخدم؟',
    ],
    stop: 'إيقاف',
    clear: 'ابدأ من جديد',
    get_help: 'احصل على مساعدة',
    copy_chat: 'نسخ',
    ask_ai_label: 'اسأل AI',
    contact: 'اتصال',
    discord: 'ديسكورد',
};
export default Object.freeze(inkeep_ai_bot);
